import { FC } from "react";
import { IKvkkInputs } from "../../../../interfaces/Contact";
import { CheckboxInput } from "../../../../components";
import useLocales from "../../../../hooks/useLocales";

const KvkkInputs: FC<IKvkkInputs> = ({
  kvkkMarkApprovalMailSend,
  kvkkMarkApprovalSmsSend,
  customerTypeId,
}) => {
  const { translate } = useLocales();

  // if (customerTypeId !== customerTypeEnum.real) {
  //   return null;
  // }

  return (
    <>
      <CheckboxInput
        name={kvkkMarkApprovalMailSend}
        label={translate(
          "resources.customers.related_persons.kvkkMarkApprovalMailSend"
        )}
        disabled={true}
      />
      <CheckboxInput
        name={kvkkMarkApprovalSmsSend}
        label={translate(
          "resources.customers.related_persons.kvkkMarkApprovalSmsSend"
        )}
        disabled
      />
    </>
  );
};

export default KvkkInputs;
